<section *ngIf="!(isLoading$ | async)" class="home gap-container">
  <ng-container *ngIf="claims?.length; else WithoutClaimTemplate">
    <app-display-large>{{
      "Outstandingactions" | translate
    }}</app-display-large>

    <div class="main" [class.multi]="multiClaims">
      <section class="outstanding">
        <app-os-actions-lst [claims]="claims"></app-os-actions-lst>
      </section>
      <section class="case-teaser">
        <app-case-teaser-list
          [multiClaims]="multiClaims"
        ></app-case-teaser-list>
      </section>
    </div>
  </ng-container>

  <ng-template #WithoutClaimTemplate>
    <app-display-large>{{
      "You don’t have any active claims at the moment" | translate
    }}</app-display-large>
    <div class="without-claim-card">
      <p>
        {{
          "Stay up to date with the latest news or explore available cases to participate again."
            | translate
        }}
      </p>
      <div class="actions">
        <button class="act-btn cancel" routerLink="/client/news">{{ "View news" | translate }}</button>
        <button class="act-btn save" routerLink="/client/cases">
          {{ "Explore our cases" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</section>
